<template>
  <el-dialog title="Novo Contato" @open="reset()" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="40%">
    <el-form size="small" label-position="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item class="form-item" label="Data/Hora">
            <el-input v-model="contatoRealizado.data" placeholder="01/01/2019 16:00" v-mask="'##/##/#### ##:##'"></el-input> 
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="form-item" label="Data/Hora de Retorno">
            <el-input v-model="contatoRealizado.dataProximoContato" placeholder="01/01/2019 16:00" v-mask="'##/##/#### ##:##'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Atendente" style="width: 100%">
            <el-select
              v-model="atendente"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                  v-for="item in usuariosDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item class="form-item" label="Assunto" style="width: 100%">
            <el-input v-model="contatoRealizado.assunto"></el-input> 
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item class="form-item" label="Descrição">
            <el-input v-model="contatoRealizado.descricao" type="textarea" :rows="8"></el-input> 
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
      
    <span slot="footer">
      <el-button type="primary" size="small" @click="gravar()">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      contatoRealizado: {
        data: "",
        dataProximoContato: "",
        assunto: "",
        descricao: "",
        cliente: {
          id: 0
        }
      },
      atendente: {},
      loadingUsuarios: false
    }
  },
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado },
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
    }),
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('clientesStore', [
      'listarUsuarios',
      'gravarContatoRealizado'
    ]),
    reset() {
      this.contatoRealizado = {
        data: "",
        dataProximoContato: "",
        assunto: "",
        descricao: "",
        cliente: {
          id: 0
        }
      };
      this.atendente = {};
      this.loadingUsuarios = false;
    },
    filtrarUsuariosSelect(queryString) {
      this.loadingUsuarios = true;

      let payload = { nome: queryString }
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;
      });
    },
    gravar() {
      this.contatoRealizado.cliente.id = this.cliente.id;
      this.showLoading();
      this.gravarContatoRealizado(this.contatoRealizado)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>